import React from 'react'
import APIS from '../../constant/EndPoint'
import ComboboxInput from '../Reusable/Form/ComboboxInput'
import TextField from '../Reusable/Form/TextInput'

const CityForm = ({ register, errors, setValue, getValues, clearErrors }: any) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
      <ComboboxInput
        url={APIS.LOCATION}
        props={{ level: 0 }}
        queryKey={"country"}
        register={register("country")}
        errors={errors?.parent}
        name={"country"}
        label={"Country"}
        setValue={setValue}
        placeholder={"Search Country"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <ComboboxInput
        url={APIS.LOCATION}
        props={{ level: 1 }}
        queryKey={"state"}
        register={register("state")}
        errors={errors?.parent}
        name={"state"}
        label={"State"}
        setValue={setValue}
        placeholder={"Search State"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <ComboboxInput
        url={APIS.LOCATION}
        props={{ level: 2 }}
        queryKey={"district"}
        register={register("parent")}
        errors={errors?.parent}
        name={"parent"}
        label={"District"}
        setValue={setValue}
        placeholder={"Search District"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
      <TextField
        label={"Code"}
        register={register("code")}
        errors={errors?.code}
      />
    </div>
  )
}

export default CityForm
